import { Badge } from '@@/Badge';

export function UnusedBadge() {
  return <Badge type="warn">未使用</Badge>;
}
